<template>
  <div class="box">
  <span
    class="status-label"
    :style="style"
  >{{ params.value.label }}</span
  >
  </div>
</template>

<script>


export default {
  name: "CellRendererStatus",
  computed: {
    style(){
      return {
        height: "32px",
        color: this.params.value.color,
        backgroundColor: `${this.params.value.color}20`
      }
    },
  },

}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

.box {
  text-align: center;
}
</style>
